import { render } from "./QuestionThreeView.vue?vue&type=template&id=1ddb60a8&scoped=true&ts=true"
import script from "./QuestionThreeView.vue?vue&type=script&lang=ts"
export * from "./QuestionThreeView.vue?vue&type=script&lang=ts"

import "./QuestionThreeView.vue?vue&type=style&index=0&id=1ddb60a8&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddb60a8"]])

export default __exports__